// components/Layout.jsx
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '@context/AuthContext';

// CSS imports
// Import Eva Icons
import 'eva-icons/style/eva-icons.css';
// Import Boxicons
import 'boxicons/css/boxicons.min.css';
// Import Material Design Icons
import '@mdi/font/css/materialdesignicons.min.css';
// Import Font Awesome 5
import '@fortawesome/fontawesome-free/css/all.min.css';
import ThemeReinit from '@/components/ThemeReinit';

// Component imports
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

// Hook for Google Maps API
//import useGoogleMapsAPI from '../hooks/useGoogleMapsAPI';

const Layout = ({ children, isAdminPage }) => {
  const { globalUser, globalData, defaultAvatarUrl, logout } = useAuth();

  const { pathname } = useLocation();

  useEffect(() => {
    const $ = window.$;
    const nav = document.querySelector('.metismenu');
    if ($?.fn?.metisMenu && nav) {
      const $nav = $(nav);
      try {
        $nav.metisMenu('dispose');
      } catch {}
      $nav.metisMenu(); // rebuild
    }
  }, [pathname]);

  /* Use Google Maps API key from environment variables
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY; //import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!googleMapsApiKey) {
    console.error('Google Maps API key is missing!');
  }

  // Load Google Maps API and track loading state
  const isGoogleMapsLoaded = useGoogleMapsAPI(googleMapsApiKey);

  if (!isGoogleMapsLoaded) {
    return <div>Loading Google Maps API...</div>; // Show a loading state
  }*/

  return (
    <>
      <div id='main-wrapper'>
        <ThemeReinit />
        <Header />
        <Sidebar />

        <div className='content-body'>
          <div className='container-fluid'>{children}</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
